import { Box, Link, Typography } from "@mui/material";

import { Button, Modal } from "@covertree/ui";

import { AGENT_HELP_ADDRESS } from "@consts/index";

interface CancellationAlreadyIssuedModalProps {
  readonly isModalOpen: boolean;
  readonly onClose: () => void;
}

export function CancellationAlreadyIssuedModal({
  isModalOpen,
  onClose,
}: CancellationAlreadyIssuedModalProps) {
  return (
    <Modal
      open={isModalOpen}
      onClose={onClose}
      title="Cancellation Already Issued"
      maxWidth={false}
      sx={{
        width: { xs: "80%", md: 720 },
        "&:focus": {
          outline: "none",
        },
      }}>
      <Typography variant="h5" sx={{ pr: 5, textAlign: "justify" }}>
        A cancellation has already been issued for this policy. This action
        cannot be completed. If you need assistance, please contact{" "}
        <Link color="secondary" href={`mailto:${AGENT_HELP_ADDRESS}`}>
          {AGENT_HELP_ADDRESS}
        </Link>
        .
      </Typography>
      <Box mt={4} columnGap={3} display="flex">
        <Button onClick={onClose}>Close</Button>
      </Box>
    </Modal>
  );
}
